export class Customer {
    name = "";
    id = "";
    crmId = "";
}